// Blackbox paywall copy (TRAD-1293 AC5), verbatim from the dashboard
// prototype at tradealgo-dashboard.vercel.app/blackbox. The benefits match the
// public /products/blackbox page (AC1): Midas Link is deliberately absent from
// both lists (removed from the design on 23 Oct 2026). TRAD-1317 restyled the
// included card: the label and the footer note gave way to an "Invite-only" chip.

export const BLACKBOX_PRODUCT_TYPE = "BLACKBOX";

export const BB_PAYWALL_EYEBROW = "BLACKBOX";

export const BB_PAYWALL_HEADLINE =
  "TradeAlgo’s Most Exclusive Investment Solution";

export const BB_PAYWALL_TAGLINE = "Beyond signals. Beyond research.";

export const BB_PAYWALL_BODY =
  "Blackbox brings together TradeAlgo’s most powerful strategies, tools, and investment solutions into one premium offering.";

export const BB_PAYWALL_INCLUDED = [
  "All Wealth Series portfolios",
  "Exclusive trading signals",
  "Professional portfolio management option",
  "Automated rebalancing",
  "Preferential advisory rates",
];

export const BB_PAYWALL_INCLUDED_CHIP = "Invite-only";

export const BB_PAYWALL_FEATURES = [
  {
    icon: "signals",
    title: "Exclusive Signals",
    body: "Receive premium trading and investment signals designed to help you identify market opportunities.",
  },
  {
    icon: "wealthSeries",
    title: "Full Access to the Wealth Series",
    body: "Unlock every portfolio within the Wealth Series through a single subscription.",
  },
];

export const BB_PAYWALL_DISCLAIMER =
  "Blackbox provides premium investment solutions for informational purposes only. Past performance is not indicative of future results. Please invest at your own discretion and consult a qualified financial adviser.";
